var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{staticClass:"included",attrs:{"value":_vm.subscribePrompt}},[_c('PromptCard',{attrs:{"text":_vm.message,"okay-text":"Subscribe","cancel-text":"Not now"},on:{"okay":_vm.handleOkay,"cancel":_vm.closePrompt}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }